module.exports = "<app-chips-basic [label]=\"labelAuthors\" \n  [items]=\"authorItems\" \n  (notify)=\"setClickAuthorItem($event)\">\n</app-chips-basic>"